// @flow

import React from 'react';
import Duration, { type DateLike } from 'app/components/shared/Duration';

type DurationFormats = 'Short' | 'Micro';
export type BuildStates = 'passed' | 'failed' | 'blocked' | 'canceled' | 'canceling' | 'skipped' | 'not_run' | 'scheduled' | 'started';

type Props = {
  durationFormat: DurationFormats,
  build: {
    state: BuildStates,
    cancelReason?: string,
    scheduledAt: ?DateLike,
    startedAt: ?DateLike,
    canceledAt: ?DateLike,
    finishedAt: ?DateLike,
    cancelledBy?: {
      avatar: string,
      name: string
    }
  }
};

export default class BuildDuration extends React.PureComponent<Props> {
  static defaultProps = {
    durationFormat: 'Short'
  };

  render() {
    const DurationFormat = Duration[this.props.durationFormat];

    if (this.props.build.state === 'passed') {
      return (
        <span>
          {"Passed in "}
          <DurationFormat
            from={this.props.build.startedAt}
            to={this.props.build.finishedAt}
          />
        </span>
      );
    } else if (this.props.build.state === 'failed') {
      return (
        <span>
          {"Failed in "}
          <DurationFormat
            from={this.props.build.startedAt}
            to={this.props.build.finishedAt}
          />
        </span>
      );
    } else if (this.props.build.state === 'blocked') {
      if (this.props.build.startedAt) {
        return (
          <span>
            {"Passed in "}
            <DurationFormat
              from={this.props.build.startedAt}
              to={this.props.build.finishedAt}
            />
            {" and blocked"}
          </span>
        );
      }

      return (
        <span>Blocked</span>
      );
    } else if (this.props.build.state === 'canceled') {
      const prefixNode = (
        this.props.build.cancelReason === "build_skipping"
          ? (
            <span
              data-toggle="tooltip"
              title="This build was automatically canceled by your Build Skipping settings"
            >
              Canceled automatically
            </span>
          )
          : (
            this.props.build.cancelledBy
              ? (
                <span>
                  <img
                    src={this.props.build.cancelledBy.avatar}
                    className="circle border border-gray bg-white"
                    style={{ width: 20, height: 20, marginRight: 2 }}
                  />
                  <strong className="semi-bold">
                    {this.props.build.cancelledBy.name}
                  </strong>
                  {" canceled"}
                </span>
              )
              : (
                <span>Canceled</span>
              )
          )
      );

      if (this.props.build.startedAt) {
        return (
          <span title={this.props.build.canceledAt}>
            {prefixNode}
            {" after "}
            <DurationFormat
              from={this.props.build.startedAt}
              to={this.props.build.canceledAt}
            />
          </span>
        );
      }

      return (
        <span title={this.props.build.canceledAt}>
          {prefixNode}
        </span>
      );
    } else if (this.props.build.state === 'canceling') {
      return (
        <span>Canceling</span>
      );
    } else if (this.props.build.state === 'skipped') {
      return (
        <span>Skipped</span>
      );
    } else if (this.props.build.state === 'not_run') {
      return (
        <span>Not Run</span>
      );
    } else if (this.props.build.state === 'scheduled') {
      return (
        <span>
          <i className="fa fa-clock-o" />
          {" "}
          <span className="xs-hide">
            Waiting for
          </span>
          {" "}
          <DurationFormat
            from={this.props.build.scheduledAt}
            live={true}
          />
        </span>
      );
    } else if (this.props.build.state === 'started') {
      return (
        <span>
          {"Running for "}
          <DurationFormat
            from={this.props.build.startedAt}
            live={true}
          />
        </span>
      );
    }

    return null;
  }
}
